import { startApplicationModal } from "./application-modal";

$(function () {
    const inputs = {
        billNr: $('[name="personal_data[billNr]"]'),
        billDate: $('[name="personal_data[billDate]"]'),
        billPos: $('[name="personal_data[billPos]"]'),
        billNip: $('[name="personal_data[billNip]"]'),
    }

    for (const [key, input] of Object.entries(inputs)) {
        if (input.length) {
            input.closest('.form-group').append(`
<button
  type="button"
  class="btn btn-input-hint-modal"
  data-bs-toggle="modal"
  data-bs-target="#modal-hint-form-application-${key}"
>
?
</button>`)
        }
    }
})

$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    // Hand off to the multi-step, uncloseable game modal instead of swapping the form
    // content. preventDefault() stops ajax-form's post-handler form.reset()/redirect.
    event.preventDefault();
    startApplicationModal(data);
});

$('[name="personal_data[billType]"]').on('change', function() {
    // Default: billPos (Numer kasy) enabled. Checking the billType control disables it; unchecking re-enables.
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', this.checked);
}).trigger('change');

// Preload the large modal background as soon as the user starts filling the bill details,
// so it is cached by the time the modal opens.
(function preloadModalBackground() {
    const bgSrc = $('#modal-form-application').data('bg-src');
    if (!bgSrc) {
        return;
    }

    const billFields = [
        'billType', 'billNr', 'billDate', 'billNip', 'billPos',
    ].map(name => `[name="personal_data[${name}]"]`).join(', ');

    let preloaded = false;
    $(document).on('focusin input change', billFields, function() {
        if (preloaded) {
            return;
        }
        preloaded = true;
        new Image().src = bgSrc;
    });
})();